<template>
  <div>
    <model-select
      v-if="items"
      :placeholder="placeholder"
      :defaultOptions="items"
      :id="idSelected"
      :canSearch="false"
      :value="null"
      :canCreate="false"
      :showTitle="false"
      classes="px-0"
      :disabled="disabled"
      @selected="onItemSelected"
    />
  </div>
</template>

<script lang="ts">
import { Component, Prop, Mixins } from "vue-property-decorator";
import ModelSelect from "components/ModelSelect.vue";
import ObjectPathMixin from "mixins/ObjectPathMixin";

@Component({ components: { ModelSelect } })
export default class CustomSelectSelect extends Mixins(ObjectPathMixin) {
  @Prop() idSelected?: string | number;
  @Prop() params;
  @Prop() dataKeys?: string;
  @Prop() placeholder: string;
  @Prop({ default: false }) disabled?: boolean;
  @Prop() items: Array<{ name: string; id: number }>;

  mounted() {}

  outputParams(data) {
    return this.outputObject(data, this.dataKeys);
  }

  onItemSelected(data) {
    this.$emit("change", this.outputParams(data));
  }
}
</script>

<style scoped></style>
